import { useCallback, useMemo, useState } from 'react';
import { verifyPayerRc } from '../../../../redux/grid/action.js';

export const useAdjustmentPopupManager = (type = 'serviceLine',setIsDragEnabled,values ,customFieldValidator ) => {
  // Popup states
  const [pcPopup, setPcPopup] = useState(false);
  
  // Data states
  const [propCodeData, setPropCodeData] = useState({
    index: '',
    serviceIndex: '',
    adjustmentIndex: ''
  });

  const [x12Codes, setx12Codes] = useState({ 
    open: false, 
    data: '',
    reason_code: '',
    index: '',
    serviceIndex: '',
    adjustmentIndex: ''
  });

  // Popup management functions
  const openPcPopup = useCallback((data) => {
    setPropCodeData(data);
    setPcPopup(true);
  }, []);

  const closePcPopup = useCallback(() => {
    setPcPopup(false);
  }, []);

  const toggleX12Codes = useCallback((data = '') => {
    setx12Codes(prev => ({ 
      ...prev,
      open: !prev.open, 
      data: typeof data === 'string' ? data : prev.data 
    }));
  }, []);

  const handleX12CodesClose = useCallback((data = '') => {
    setx12Codes({ open: false, data: "" });
    setIsDragEnabled(true);
  }, []);

  // Reset all states
  const resetAllStates = useCallback(() => {
    setPcPopup(false);
    setPropCodeData({
      index: '',
      serviceIndex: '',
      adjustmentIndex: ''
    });
    setx12Codes({ 
      open: false, 
      data: '',
      reason_code: '',
      index: '',
      serviceIndex: '',
      adjustmentIndex: ''
    });
  }, []);

  // Handle payer PC verification
  const handlePayerPcVerify = useCallback((e, index, serviceIndex, adjustmentIndex,updateAdjustment,claims,setCurrentAdjRef,isClaim) => {
    const event = e.target;
    const value = event.value;

    if (value?.length >= 1 && (e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 39)) {
      if (values?.payer_id || values?.payer_name) {
        const payer_id = values?.payer_id;
        const reasoncodes = value ? value?.toUpperCase() : "";

        verifyPayerRc(reasoncodes, payer_id)((response) => {
          if (response?.status && response?.status_code == 200) {
            setPcPopup(false);
            setIsDragEnabled(true);
            insertPropCodeFormik(
              event,
              response?.data,
              index,
              serviceIndex,
              adjustmentIndex,
              updateAdjustment,
              claims,
              setCurrentAdjRef,
              isClaim
            );
            setPropCodeData({
              index: index,
              serviceIndex: serviceIndex,
              adjustmentIndex: adjustmentIndex,
            });
          } else {
            setPcPopup(true);
            setx12Codes({
              open: false,
              data: "",
              reason_code: '',
              index: '',
              serviceIndex: '',
              adjustmentIndex: ''
            });
            setIsDragEnabled(false);
            setPropCodeData({
              index: index,
              serviceIndex: serviceIndex,
              adjustmentIndex: adjustmentIndex,
            });
          }
        });
      }
    } else {
      setPcPopup(false);
      setx12Codes({
        open: false,
        data: "",
        reason_code: '',
        index: '',
        serviceIndex: '',
        adjustmentIndex: ''
      });
    }
  }, [setIsDragEnabled,values]);

  // Insert prop code formik
  const insertPropCodeFormik = useCallback((event,values, index, serviceIndex, adjustmentIndex, updateAdjustment, claims,setCurrentAdjRef,isClaim) => {
    
    if (values?.x12codes?.length > 1) {
      setPcPopup(false);

      setx12Codes({
        open: true,
        reason_code: values?.reason_code?.toUpperCase(),
        data: values?.x12codes,
        index: index,
        serviceIndex: serviceIndex,
        adjustmentIndex: adjustmentIndex,
      });
      setCurrentAdjRef(event)
      setIsDragEnabled(false);
    } else {
      setx12Codes({
        open: false,
        data: "",
        reason_code: '',
        index: '',
        serviceIndex: '',
        adjustmentIndex: ''
      });
      const oldAdj =( isClaim ? claims[0]?.claim_adjustments?.[adjustmentIndex]  : claims[0]?.service_lines?.[serviceIndex]?.adjustments?.[adjustmentIndex] )||{}
 
      const dict = {...oldAdj};
      
      // Handle both service line and claim adjustments
      if (serviceIndex !== null && serviceIndex !== undefined) {
        // Service line adjustment
        dict.pc = claims[index].service_lines[serviceIndex].adjustments[adjustmentIndex].pc;
      } else {
        // Claim adjustment
        dict.pc = claims[index].claim_adjustments[adjustmentIndex].pc;
      }
      
      dict.reason_code = values?.x12codes[0]?.carc;
      dict.rmk = values?.x12codes[0]?.rarc;
      dict.group_code = values?.x12codes[0]?.group_code;
      dict.description = values?.x12codes[0]?.description;
      dict.reasoncode_id = values?.x12codes[0]?.reasoncode_id;
      
      updateAdjustment(adjustmentIndex, dict);
      
      
          const validatePath =  isClaim ?   `claims.${0}.claim_adjustments.${adjustmentIndex}` :`claims.${0}.service_lines.${serviceIndex}.adjustments.${adjustmentIndex}` 

      customFieldValidator([validatePath])
    }
  }, [setx12Codes]);

  // Handle multiple prop codes
  const handleMultiplePropCode = useCallback((x12Index, updateAdjustment ,adjFullData = {} ,validatePath) => {
    const dict = {...adjFullData};
    dict.pc = x12Codes?.reason_code ? x12Codes?.reason_code?.toUpperCase() : "";
    dict.reason_code = x12Codes?.data[x12Index]?.carc ? x12Codes?.data[x12Index]?.carc?.toUpperCase() : "";
    dict.rmk = x12Codes.data[x12Index]?.rarc ? x12Codes.data[x12Index]?.rarc?.toUpperCase() : "";
    dict.group_code = x12Codes.data[x12Index]?.group_code;
    dict.description = x12Codes.data[x12Index]?.description;
    dict.reasoncode_id = x12Codes.data[x12Index]?.reasoncode_id;
    
    updateAdjustment(x12Codes.adjustmentIndex, dict);
    
    customFieldValidator([validatePath])
    
    setx12Codes({ 
      open: false, 
      data: "",
      reason_code: '',
      index: '',
      serviceIndex: '',
      adjustmentIndex: ''
    });
    setIsDragEnabled(true);
  }, [x12Codes]);

  // Double click handlers
  const handleDoubleClickAdjustment = useCallback((dict, e, index1, serviceIndex, adjustmentIndex) => {
    if ((values.payer_id && values.payer_id !== '') || (values.payer_name && values.payer_name !== "")) {
      const popupData = {
        index: index1,
        serviceIndex: serviceIndex,
        adjustmentIndex: adjustmentIndex,
      };

      // Determine if this is a service line or claim adjustment
      openPcPopup(popupData);
      setIsDragEnabled(false);
    }
  }, [openPcPopup,setIsDragEnabled,values]);

  // Memoized state
  const memoizedState = useMemo(() => ({
    pcPopup,
    propCodeData,
    x12Codes,
    type
  }), [pcPopup, propCodeData, x12Codes, type]);

  return {
    ...memoizedState,
    // State setters
    setPropCodeData,
    setx12Codes,    
    // Popup controls
    openPcPopup,
    closePcPopup,
    toggleX12Codes,
    resetAllStates,
    
    // Action handlers
    handlePayerPcVerify,
    insertPropCodeFormik,
    handleMultiplePropCode,
    handleDoubleClickAdjustment,
    handleX12CodesClose
  };
};